import { Flex } from '@chakra-ui/react';
import { Chat, ChatProvider } from '@duke-hq/svc-support-web';

import { DetailProps } from '@duke-hq/ui/components/ListDetail/ListDetail';

import { SupportContext } from './ctx';
import { useContext } from 'react';
import { useAuthAdmin } from '../../AuthProviderAdmin';

export function Detail<Item, ItemId extends string>(props: DetailProps<Item, ItemId>) {
  return (
    <Flex
      flexDirection="column"
      width="100%"
      height="100%"
      display={props.isSelected ? 'flex' : 'none'}
    >
      {props.item?.id ? <ChatDetail key={props.item.id} id={props.item.id} /> : null}
    </Flex>
  );
}

function ChatDetail({ id }: { id: string }) {
  const { actions } = useContext(SupportContext);
  const auth = useAuthAdmin();

  if (!auth?.user?.drn) {
    return null;
  }
  return (
    <ChatProvider chatActions={actions}>
      <Flex flexDirection="column" width="100%" height="100%">
        <Chat key={id} chatId={id} currentUserDrn={auth.user.drn} />
      </Flex>
    </ChatProvider>
  );
}
